export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_GET_SUCCESS = 'USER_GET_SUCCESS';
